import { verifiedChannelCustomTypes } from '@inbox-demo-nx/constants';
import SendBird from 'sendbird';

export function isChannelVerified(channel: SendBird.GroupChannel) {
  return verifiedChannelCustomTypes.includes(channel.customType as any);
}
